// The community Discord invite, in exactly one place.
//
// Before this file the invite lived in four spots: BracketPage read
// VITE_DISCORD_INVITE while AboutPage and SupportPage hardcoded the URL, so
// rerolling the invite meant finding all of them and the two iOS copies.
//
// The env var still wins so the invite can be repointed without a code change,
// but it is an OVERRIDE and no longer a GATE. The old
// `{import.meta.env.VITE_DISCORD_INVITE && <a .../>}` pattern meant an unset or
// mistyped Vercel variable silently deleted the CTA from the results page with
// nothing failing anywhere - and the results page is 117K impressions a month.
// A wrong-but-present link is a visible bug; a missing one is invisible.
const FALLBACK_INVITE = 'https://discord.gg/qU8Eec4fyj'

const configured = (import.meta.env.VITE_DISCORD_INVITE as string | undefined)?.trim()

export const DISCORD_INVITE_URL = configured || FALLBACK_INVITE
